
<template>
  <!--制卡记录-->
  <div>
    <x-tabula
      ref="table"
      @resetSearch="resetSearch"
      :dataSource="dataSource"
      rowKey="cardId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_roomList" slot-scope="{row}">
        <template v-if="row.roomList && row.roomList.length">
          <a-tooltip>
            <template slot="title" v-for="(item, index) of row.roomList">
              <p :key="index">{{item}}</p>
            </template>

            <template v-for="(item, index) of row.roomList.slice(0, 2)">
              <div :key="index">{{item}}</div>
            </template>
            <span v-if="row.roomList.length > 2">...</span>
          </a-tooltip>
        </template>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <span>{{row.status === 1 ? '正常' : '禁用'}}</span>
      </template>
      <template slot="opt_isCopy" slot-scope="{row}">
        <span>{{row.isCopy === '1' ? '是' : '否'}}</span>
      </template>
      <template slot="opt_memberType" slot-scope="{row}">
        <span>{{row.memberType === '1' ? '住户' : '管家'}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../utils/mixins';
import { empty } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect],
  name: 'cardRecord',
  data () {
    return {
      tempSearchList: [
        { props: [`${this.$route.name}/buildingId`], placeholder: ['楼栋'], options: [], inputType: 'select', handle: e => this.buildingChange(10, e) },
        { props: [`${this.$route.name}/unitId`], placeholder: ['单元'], options: [], inputType: 'select', handle: e => this.unitChange(11, e) },
        { props: [`${this.$route.name}/roomId`], placeholder: ['房间'], options: [], inputType: 'select', disable: true}
      ],
      searchList: [
        { props: [`${this.$route.name}/communityId`], placeholder: '小区名称', options: [], inputType: 'select', handle: e => this.communityChange(9, e), fetchOptions: this.getOptions},
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['cardno'], placeholder: '卡号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['isCopy'], placeholder: '是否复制', options: this.$store.state.booleanList, inputType: 'select' },
        {
          props: ['areaId'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(5, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        // { props: ['isEncrypt'], placeholder: '制卡模式', options: this.$store.state.makeCardList, inputType: 'select' },
        { props: ['memberType'], placeholder: '住户类型', options: [{label: '住户', value: 1}, {label: '管家', value: 2}], inputType: 'select', handle: (e) => this.memberTypeChange(e)},
        { props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
        // { props: [`${this.$route.name}/buildingId`], placeholder: ['楼栋'], options: [], inputType: 'select', handle: e => this.buildingChange(10, e) },
        // { props: [`${this.$route.name}/unitId`], placeholder: ['单元'], options: [], inputType: 'select', handle: e => this.unitChange(11, e) },
        // { props: [`${this.$route.name}/roomId`], placeholder: ['房间'], options: [], inputType: 'select', disable: true}
      ],
      tableOptList: [],
      rowOptList: [
        { text: '', customRender: true, handle: (row) => this.triggerStatus(row), peri: ['community:card:editstatus'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), key: 'delete', permi: ['community:card:remove'] }
      ],
      columns: [
        { title: '卡号', dataIndex: 'cardno', align: 'left', width: '' },
        // { title: '制卡模式', dataIndex: 'encryptDesc', align: 'left', width: '' },
        { title: '小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '房间', dataIndex: 'roomList', align: 'left', width: '', scopedSlots: {customRender: 'roomList'} },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '持卡人', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '住户类型', dataIndex: 'memberType', align: 'left', width: '', scopedSlots: {customRender: 'memberType'} },
        { title: '添加时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '备注', dataIndex: 'remark', align: 'left', width: '' },
        { title: '是否复制', dataIndex: 'isCopy', align: 'left', width: '', scopedSlots: {customRender: 'isCopy'} },
        { title: '状态', dataIndex: 'status', align: 'left', width: '', scopedSlots: {customRender: 'status'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        [`${this.$route.name}/communityId`]: undefined,
        mobile: undefined,
        cardno: undefined,
        status: undefined,
        areaId: undefined,
        propertyId: undefined,
        isEncrypt: undefined,
        memberType: undefined,
        createDate: undefined,
        isCopy: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        [`${this.$route.name}/unitId`]: undefined,
        [`${this.$route.name}/roomId`]: undefined
      },
      listApi: {
        url: '/card/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: this.searchHandle
      },
      deleteParam: {
        url: '/card/',
        // param: { pk_key: 'cardId', pk_val: '' },
        title: '制卡记录',
        key: 'cardno'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    memberTypeChange (memberType) {
      if (memberType == 1) {
        this.searchList = this.searchList.concat(this.tempSearchList);
        this.tempSearchList = [];
      } else if (memberType == 2) {
        if (this.searchList.length > 9) {
          this.searchList[10].options = [];
          this.searchList[11].options = [];
          this.tempSearchList = this.searchList.splice(9, 3);
        }
      } else if (this.searchList.length > 9) {
        this.searchList[10].options = [];
        this.searchList[11].options = [];
        this.tempSearchList = this.searchList.splice(9, 3);
      }
    },
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.propertySelect(6);
      this.regionSelect(5);
    },
    /** 清空搜索 */
    resetSearch () {
      if (this.searchList.length > 9) {
        this.searchList[9].options = [];
        this.searchList[10].options = [];
        this.searchList[11].options = [];
        this.tempSearchList = this.searchList.splice(9, 3);
      } else {
        this.tempSearchList[0].options = [];
        this.tempSearchList[1].options = [];
        this.tempSearchList[2].options = [];
      }
      empty.$emit('resetForm', ['buildingId', 'unitId', 'roomId']);
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    triggerStatus (row) {
      let status;
      row.status === 0 ? status = 1 : status = 0;
      this.$put({
        url: '/card/changeStatus',
        params: {
          cardId: row.cardId,
          status: status
        }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      res.forEach(item => {
        if (item.roomList && item.roomList.length) {
          item.roomList = item.roomList.split(',');
        }
      });
      return res;
    },
    searchHandle (selectData) {
      if (selectData.memberType != 1) {
        selectData[`${this.$route.name}/buildingId`] = undefined;
        selectData[`${this.$route.name}/unitId`] = undefined;
        selectData[`${this.$route.name}/roomId`] = undefined;
      }
      return selectData;
    }
  }
};
</script>
